__webpack_require__.p = "/hris-dashboard/";